'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import Axios from '@/lib/axiosConfig';
import { useAuth } from '@/context/Auth';
import { toast } from 'sonner';

export const usePinPostMutation = () => {
  const { getAPIRequestTokenHeaders } = useAuth();
  const queryClient = useQueryClient();

  return useMutation<any, Error, { groupID: string; postID: string; isPinned: boolean }>({
    mutationFn: ({ groupID, postID, isPinned }) => {
      if (isPinned) {
        // Unpin
        return Axios.delete(`/groups/${groupID}/pin`, {
          headers: getAPIRequestTokenHeaders(),
        }).then((res) => res.data);
      } else {
        // Pin
        return Axios.post(
          `/groups/${groupID}/posts/${postID}/pin`,
          {},
          { headers: getAPIRequestTokenHeaders() }
        ).then((res) => res.data);
      }
    },
    onSuccess: (_data, variables) => {
      toast.success(
        variables.isPinned ? 'Post unpinned' : 'Post pinned to top'
      );
      queryClient.invalidateQueries({ queryKey: ['community', variables.groupID] });
      queryClient.invalidateQueries({ queryKey: ['community', variables.groupID, 'posts'] });
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.data?.message || 'Failed to update pin status'
      );
    },
  });
};
